<template>
  <div class="flow-menu" ref="tool">
    <div v-for="menu  in  menuList" :key="menu.id">
      <span class="menuTop">{{menu.name}}</span>
      <ul class="ef-node-menu-ul">
        <draggable @end="end" @start="move" v-model="menu.children" :options="draggableOptions">
          <li v-for="subMenu in menu.children" class="ef-node-menu-li" :key="subMenu.id" :type="subMenu.type">
            {{subMenu.name}}
          </li>
        </draggable>
      </ul>
    </div>
  </div>
</template>
<script>
  import draggable from 'vuedraggable'

  var mousePosition = {
    left: -1,
    top: -1
  }

  export default {
    data() {
      return {
        activeNames: '1',
        // draggable配置参数参考 https://www.cnblogs.com/weixin186/p/10108679.html
        draggableOptions: {
          preventOnFilter: false,
          sort: false,
          disabled: false,
          ghostClass: 'tt',
          // 不使用H5原生的配置
          forceFallback: true
        },
        // 默认打开的左侧菜单的id
        defaultOpeneds: ['1', '2'],
        menuList: [
          {
            id: '1',
            type: 'group',
            name: this.$t('approvalFlowConfigManagement.Node.nodeContent'),
            children: []
          }
        ],
        nodeMenu: {}
      }
    },
    components: {
      draggable
    },
    created() {
      /**
       * 以下是为了解决在火狐浏览器上推拽时弹出tab页到搜索问题
       * @param event
       */
      if (this.isFirefox()) {
        document.body.ondrop = function (event) {
          // 解决火狐浏览器无法获取鼠标拖拽结束的坐标问题
          mousePosition.left = event.layerX
          mousePosition.top = event.clientY - 50
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
    methods: {
      // 根据公司查询节点
      async queryNodesByCompanyId(companyId) {
        await this.$api.processNode.queryNodesByCompanyId('companyId', companyId)
          .then(res => {
            this.menuList[0].children = res.data;
          })
        return this.menuList[0].children
      },
      // 根据类型获取左侧菜单对象
      getMenuByType(type) {
        for (let i = 0; i < this.menuList.length; i++) {
          let children = this.menuList[i].children;
          for (let j = 0; j < children.length; j++) {
            if (children[j].type === type) {
              return children[j]
            }
          }
        }
      },
      // 拖拽开始时触发
      move(evt, a, b, c) {
        var type = evt.item.attributes.type.nodeValue
        this.nodeMenu = this.getMenuByType(type)
      },
      // 拖拽结束时触发
      end(evt, e) {
        this.$emit('addNode', evt, this.nodeMenu, mousePosition)
      },
      // 是否是火狐浏览器
      isFirefox() {
        var userAgent = navigator.userAgent
        if (userAgent.indexOf("Firefox") > -1) {
          return true
        }
        return false
      }
    }
  }
</script>
<style scoped>
  .menuTop {
    width: 100.1%;
    height: 32px;
    background-color: #F1F3F4;
    display: block;
    line-height: 32px;
    padding-left: 21px;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 15px;
    color: #575757;
  }
</style>



// WEBPACK FOOTER //
// src/components/ef/node_menu.vue